/**
 * 维保设备模块（src/views/maintenanceDevice）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定删除吗?': 'Are you sure you want to delete?',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '删除': 'Delete',
  '编辑': 'Edit',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '批量处理': 'Batch Handle',
  '处理': 'Handle',
  '清空': 'Clear',
  '操作': 'Action',
  '创建时间': 'Created At',
  '创建人': 'Created By',
  '导出': 'Export',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '展开': 'Expand',
  '收起': 'Collapse',
  '已选择 {count} 项': '{count} items selected',
  '其他': 'Other',
  '未知': 'Unknown',
  '有': 'Yes',
  '无': 'None',
  '正常': 'Normal',
  '欠压': 'Undervoltage',
  '故障': 'Fault',
  '个': 'pcs',
  '天': 'Day',
  '元': 'CNY',
  '请选择': 'Please select',
  // ── 设备/信号/电池 ──
  '表编号': 'Meter No.',
  '表号': 'Meter No.',
  '表类型': 'Meter Type',
  '表口径': 'Meter Caliber',
  '表安装地址': 'Meter Installation Address',
  '用户编号': 'Customer No.',
  '用户姓名': 'Customer Name',
  '用户地址': 'Customer Address',
  '表具信息': 'Meter Info',
  '表具总数': 'Total Meters',
  '表具历史数据': 'Meter History Data',
  '模组号': 'Module No.',
  '运行密钥': 'Operating Key',
  '根密钥': 'Root Key',
  '信号 rsrp值': 'Signal RSRP',
  '信号rsrp值': 'Signal RSRP',
  '信号snr值': 'Signal SNR',
  '信号csq值': 'Signal CSQ',
  '信号rsrq值': 'Signal RSRQ',
  '信号覆盖等级': 'Signal Coverage Level',
  '电池状态': 'Battery Status',
  '电池电压(V)': 'Battery Voltage (V)',
  '电池电压': 'Battery Voltage',
  '电池电压分析': 'Battery Voltage Analysis',
  '电池电压图形分析': 'Battery Voltage Chart Analysis',
  '电池电压告警': 'Battery Voltage Alarm',
  '电池电压折线统计图': 'Battery Voltage Line Chart',
  '电池电压输入有误': 'Invalid battery voltage input',
  '电压范围': 'Voltage Range',
  '电压值最小值': 'Minimum Voltage',
  '电压值最大值': 'Maximum Voltage',
  '系统时间': 'System Time',
  '表端时间': 'Meter Time',
  '软件版本号': 'Software Version',
  '运营商': 'Carrier',
  '部门': 'Department',
  '部门编号': 'Department Code',
  '部门名称': 'Department Name',
  '所属公司': 'Company',
  '温度': 'Temperature',
  '温度(℃)': 'Temperature (℃)',
  'HSI标准': 'HSI Standard',
  // ── 上报/数据 ──
  '上报方式': 'Report Method',
  '上报累计流量(m³)': 'Reported Total Flow (m³)',
  '日冻结数据': 'Daily Freeze Data',
  '存储状态': 'Storage Status',
  '最近上报时间': 'Last Report Time',
  '最近上报总用量(m³)': 'Last Reported Total Usage (m³)',
  '最近上报阀门状态': 'Last Valve Status',
  '未上报查询': 'Not Reported Query',
  '距今': 'From Now',
  '查询起止时间': 'Query Time Range',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  '告警日期': 'Alarm Date',
  '历史图表': 'History Chart',
  '自定义列': 'Custom Columns',
  '定时上传': 'Scheduled Upload',
  '上电上传': 'Power-on Upload',
  '手动上传': 'Manual Upload',
  '故障上传': 'Fault Upload',
  '定时上报': 'Scheduled Report',
  '上电上报': 'Power-on Report',
  '手动上报': 'Manual Report',
  '故障上报': 'Fault Report',
  '阀门动作上报': 'Valve Action Report',
  '读卡上报': 'Card Read Report',
  '高频上报': 'High-frequency Report',
  // ── 阀门/故障 ──
  '阀门状态': 'Valve Status',
  '阀门是否故障': 'Valve Fault',
  '有无磁干扰': 'Magnetic Interference',
  '关阀': 'Close Valve',
  '开阀': 'Open Valve',
  '强制开阀': 'Force Open Valve',
  '强制关阀': 'Force Close Valve',
  '无阀': 'No Valve',
  '阀门开故障': 'Valve Open Fault',
  '阀门关故障': 'Valve Close Fault',
  '阀门锈死故障': 'Rusted Valve Fault',
  '无到位信号': 'No In-place Signal',
  '走水量': 'Water Usage',
  '走水量(m³)': 'Water Usage (m³)',
  '关阀走水': 'Valve-closed Water Usage',
  '关阀走水量': 'Valve-closed Water Usage',
  '关阀期间流失的用水量': 'Water usage lost while valve closed',
  '超声波水表': 'Ultrasonic Water Meter',
  '暖通阀': 'HVAC Valve',
  '昨日': 'Yesterday',
  '今日': 'Today',
  // ── 告警/处理 ──
  '告警等级': 'Alarm Level',
  '告警类型': 'Alarm Type',
  '告警规则': 'Alarm Rule',
  '告警规则名称': 'Alarm Rule Name',
  '告警描述': 'Alarm Description',
  '告警时间': 'Alarm Time',
  '处理状态': 'Handling Status',
  '处理进度': 'Handling Progress',
  '处理时间': 'Handling Time',
  '处理描述': 'Handling Description',
  '未处理': 'Unprocessed',
  '处理中': 'Processing',
  '已处理': 'Processed',
  '失联告警': 'Lost-Contact Alarm',
  '失联天数': 'Lost-Contact Days',
  '失联时间': 'Lost-Contact Time',
  '失联告警时间': 'Lost-Contact Alarm Time',
  '历史电压告警记录': 'Voltage Alarm History',
  '历史失联告警记录': 'Lost-Contact Alarm History',
  '历史复位告警记录': 'Reset Alarm History',
  '历史关阀走水记录': 'Valve-closed Water Usage History',
  '复位告警': 'Reset Alarm',
  '复位状态变化': 'Reset Status Change',
  '已开户失联告警': 'Lost-Contact Alarm (Account Opened)',
  '未开户失联告警': 'Lost-Contact Alarm (Account Not Opened)',
  '信号告警': 'Signal Alarm',
  '是否开户': 'Account Opened',
  '已建档': 'Filed',
  '未建档': 'Not Filed',
  '问题表数': 'Faulty Meter Count',
  '问题表清单': 'Faulty Meter List',
  '总数量': 'Total',
  '占比': 'Percentage',
  '数据详情': 'Data Details',
  '输入表号进行查询': 'Enter meter No. to search',
  '请先选择需要批量处理的表号': 'Please select meters to batch process first',
  '请先选择需要批量处理的记录': 'Please select records to batch process first',
  '选择批量处理的处理进度不一致不能操作，请重新选择同一处理进度的表具': 'Selected records have different handling progress and cannot be processed together. Please re-select meters with the same handling progress',
  '请设置url.list属性!': 'Please set the url.list property!',
  // ── 命令 ──
  '命令下发': 'Send Command',
  '命令队列': 'Command Queue',
  // ── 告警规则配置 ──
  '规则名称': 'Rule Name',
  '规则名称模糊查询': 'Enter rule name to search',
  '规则类型': 'Rule Type',
  '比较值': 'Compare Value',
  '次数阈值(输入0代表不限制)': 'Times Threshold (0 for unlimited)',
  '失联告警天数': 'Lost-Contact Alarm Days',
  '是否启用': 'Enabled',
  '未启用': 'Not Enabled',
  '启用': 'Enabled',
  '备注': 'Remark',
  '输入有误': 'Invalid input',
  // ── 校验/占位提示 ──
  '请表类型': 'Select meter type',
  '请输入表编号': 'Please enter meter No.',
  '请输入表编号查询': 'Enter meter No. to search',
  '请输入用户编号查询': 'Enter customer No. to search',
  '请输入用户姓名查询': 'Enter customer name to search',
  '请输入模组号查询': 'Enter module No. to search',
  '输入软件版本号查询': 'Enter software version to search',
  '请输入电池状态': 'Select battery status',
  '请输入有无磁干扰': 'Select magnetic interference',
  '请输入告警天数': 'Please enter alarm days',
  '请输入关阀走水量': 'Please enter valve-closed water usage',
  '请输入比较值': 'Please enter compare value',
  '请输入次数阈值': 'Please enter times threshold',
  '请输入规则名称': 'Please enter rule name',
  '请输入备注': 'Please enter remark',
  '请输入处理描述': 'Please enter handling description',
  '请选择告警等级': 'Please select alarm level',
  '请选择告警类型': 'Select alarm type',
  '请选择规则类型': 'Please select rule type',
  '请选择处理状态': 'Please select handling status',
  '请选择是否开户': 'Please select whether the account is opened',
  '请选择上报方式': 'Please select report method',
  '请选择表口径': 'Please select meter caliber',
  '请选择运营商': 'Select carrier',
  '请选择部门': 'Please select department',
  '请选择阀门是否故障': 'Please select valve fault',
  '请选择阀门状态': 'Select valve status',
  // ── 运营商 ──
  '电信OC': 'China Telecom OC',
  '电信AEP': 'China Telecom AEP',
  '移动': 'China Mobile',
  '联通': 'China Unicom'
}
